import { Platform, PlatformUnit } from "./types";

// The stepper stages, shared with PlatformStepper.
export const PLATFORM_STEPS = [
  "Available",
  "In Transit",
  "At Dock",
  "Returning",
] as const;

export type PlatformStep = (typeof PLATFORM_STEPS)[number];

export const MAINTENANCE_STEPS = [
  "Available",
  "In Transit",
  "In Maintenance",
  "Returning",
] as const;

export function maintenanceStepIndex(rawStatus: string): number {
  switch (rawStatus) {
    case "InStorage":
      return 0;
    case "ToMaintenanceRequested":
    case "MovingToMaintenance":
      return 1;
    case "InMaintenance":
      return 2;
    case "ReturnFromMaintenanceRequested":
    case "Returning":
      return 3;
    default:
      return 0;
  }
}

export function mapPlatformStatus(status: string): string {
  switch (status) {
    case "Idle": // LogiCS
    case "InStorage": // VLC
      return "Available";
    case "Retrieving":
    case "RetrievalRequested": // VLC
      return "In Transit";
    case "AtDock":
    case "CheckStatus": // LogiCS
      return "At Dock";
    case "Storing": // LogiCS
    case "Returning": // VLC
    case "StorageRequested": // VLC
      return "Returning";
    case "InMaintenance":
    case "MovingToMaintenance":
    case "ToMaintenanceRequested":
    case "ReturnFromMaintenanceRequested":
      return "Maintenance";
    case "Fault":
      return "Fault";
    default:
      return status;
  }
}

// A unit reflects the platform's state only while it is the one in flight;
// every other mapped unit is simply sitting in storage ("Available").
export function unitDisplayStatus(platform: Platform, unit: PlatformUnit): string {
  return platform.currentUnitId === unit.unitId
    ? mapPlatformStatus(platform.status)
    : "Available";
}

// Light pill colors keyed by display label (inline hex — the robotics bundle
// has no Tailwind / theme CSS variables).
export function statusPill(label: string): { bg: string; border: string; text: string } {
  switch (label) {
    case "Available":
      return { bg: "#ecfdf5", border: "#6ee7b7", text: "#059669" };
    case "In Transit":
      return { bg: "#eff6ff", border: "#93c5fd", text: "#2563eb" };
    case "At Dock":
      return { bg: "#f0fdfa", border: "#5eead4", text: "#0d9488" };
    case "Opened":
      return { bg: "#eef2ff", border: "#a5b4fc", text: "#4f46e5" };
    case "Returning":
      return { bg: "#fff7ed", border: "#fdba74", text: "#c2410c" };
    case "Maintenance":
      return { bg: "#fefce8", border: "#fde047", text: "#a16207" };
    case "Fault":
      return { bg: "#fef2f2", border: "#fca5a5", text: "#dc2626" };
    default:
      return { bg: "#f1f5f9", border: "#cbd5e1", text: "#475569" };
  }
}
